import { render, staticRenderFns } from "./UploadTdrForm.vue?vue&type=template&id=7a4295e6"
import script from "./UploadTdrForm.vue?vue&type=script&lang=ts"
export * from "./UploadTdrForm.vue?vue&type=script&lang=ts"
import style0 from "./UploadTdrForm.vue?vue&type=style&index=0&id=7a4295e6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports